import { render, staticRenderFns } from "./AddElementCard.vue?vue&type=template&id=92dfefdc"
import script from "./AddElementCard.vue?vue&type=script&lang=ts"
export * from "./AddElementCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports